import upperCase from 'lodash/upperCase';
export const _upperCase = upperCase;
